import { Box, Grid, Typography } from "@mui/material";
import {
    required,
    SimpleShowLayout,
    TextField,
    useTranslate,
} from "react-admin";
import { CountryField } from "./fields/Ra/CountryField";

export const AddressFormShow = () => {
    const translate = useTranslate();

    return (
        <Box
            sx={{
                border: "1px solid gray",
                borderRadius: 2,
                padding: 2,
                width: "100%",
            }}
        >
            <Box sx={{ my: 1, ml: 2 }}>
                <Typography variant="body1" gutterBottom>
                    {translate("equip.address", { addressNumber: "" })}
                </Typography>
            </Box>
            <Grid container spacing={2} rowSpacing={0}>
                <Grid size={{ md: 6, xs: 12 }}>
                    <Box>
                        <SimpleShowLayout>
                            <TextField
                                sx={{ display: "block" }}
                                label="equip.firstname"
                                title={translate("equip.firstname")}
                                source="address.firstname"
                            />
                            <TextField
                                sx={{ display: "block" }}
                                label="equip.lastname"
                                title={translate("equip.lastname")}
                                source="address.lastname"
                            />
                            <TextField
                                sx={{ display: "block" }}
                                source="address.gender"
                                label="equip.gender"
                                title="equip.gender"
                            />
                            <TextField
                                sx={{ display: "block" }}
                                label={translate("equip.address", {
                                    addressNumber: "1",
                                })}
                                title={translate("equip.address", {
                                    addressNumber: "1",
                                })}
                                source="address.address1"
                                validate={[required()]}
                            />
                            <TextField
                                sx={{ display: "block" }}
                                label={translate("equip.address", {
                                    addressNumber: "2",
                                })}
                                title={translate("equip.address", {
                                    addressNumber: "2",
                                })}
                                source="address.address2"
                            />
                            <TextField
                                sx={{ display: "block" }}
                                label={translate("equip.address", {
                                    addressNumber: "3",
                                })}
                                title={translate("equip.address", {
                                    addressNumber: "3",
                                })}
                                source="address.address3"
                            />
                        </SimpleShowLayout>
                    </Box>
                </Grid>
                <Grid size={{ md: 6, xs: 12 }}>
                    <Box>
                        <SimpleShowLayout>
                            <CountryField label={translate("equip.country")} />
                            <TextField
                                sx={{ display: "block" }}
                                label="equip.zip"
                                title={translate("equip.zip")}
                                source="address.zip"
                            />
                            <TextField
                                sx={{ display: "block" }}
                                label="equip.city"
                                title={translate("equip.city")}
                                source="address.city"
                            />
                            <TextField
                                sx={{ display: "block" }}
                                label="equip.email"
                                title={translate("equip.email")}
                                source="address.email"
                            />
                            <TextField
                                sx={{ display: "block" }}
                                label="equip.phone"
                                title={translate("equip.phone")}
                                source="address.phone"
                            />
                            <TextField
                                sx={{ display: "block" }}
                                label="equip.fax"
                                title={translate("equip.fax")}
                                source="address.fax"
                            />
                        </SimpleShowLayout>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};
